<template>
  <div class="title">
    <p>{{ text?text:$route.meta.name }}</p>
    <span v-if="customer.accountType=='2'">トライアル残り回数：{{customer.availableCount-customer.currentCount}}/{{customer.availableCount}}</span>
    <span v-else>使用済み回数：{{customer.currentCount}}</span>
  </div>
</template>
<script>
import {customerDetail} from '@/http/evidence'

export default {
  props: {
    text: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      customer: {}
    }
  },
  methods: {
    async init() {
      customerDetail().then(res=>{
        if(res.code===0){
          this.customer = res.data
          this.$emit('getCustomer',res.data)
        }
      })
    }
  },
  created() {
    this.init()
  }
}
</script>
<style scoped lang="less">
.title {
  font-size: 18px;
  font-weight: 500;
  color: #90ADF7;
  letter-spacing: 1px;
  border-bottom: 4px #90ADF7 solid;
  padding: 0 0 8px;
  display: flex;
  justify-items: flex-end;
  justify-content: space-between;
  align-items: center;
  span{
    font-size: 16px;
  }
}
</style>